import { Component, OnInit } from '@angular/core';
import { Validators, FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationService } from '../../../services/notification.service';
import { CountriesService } from '../../../services/countries.service';
import { AppConfig } from '../../../app.config';

@Component({
  selector: 'app-add-messaging-bundle',
  templateUrl: './add-messaging-bundle.component.html',
  styleUrls: ['./add-messaging-bundle.component.scss'],
  providers: [MessageService]
})
export class AddMessagingBundleComponent implements OnInit {

  public BundleForm: FormGroup;
  public countries : any = [];
  public busy = false;

  constructor(
    private fb: FormBuilder,
    public modal : NgbActiveModal,
    public messageService : MessageService,
    private notificationService : NotificationService,
    private countriesService : CountriesService,
    public appConfig : AppConfig
  ) { 
     //this.appConfig.getSupportedCountries();
     this.countriesService.getAllCountries().subscribe(countries=>{
      this.countries = countries.map(x=>{return {...x, label: x.country, value: x.code}}); 
    });
  }

  ngOnInit() {
    this.BundleForm = this.fb.group({
      'packageDescription': new FormControl('', Validators.required),
      'country': new FormControl('', Validators.required),
      'locale': new FormControl('', Validators.required),
      'typeID': new FormControl(3, Validators.required),
      'credits': new FormControl('', Validators.required),
      'currency': new FormControl('', Validators.required),
      'currencySymbol': new FormControl('', Validators.required),
      'amount': new FormControl('', Validators.required),
    });
  }

  saveBundle(bundle){
    this.busy = true;
    this.notificationService.addBundle(bundle).subscribe(result=>{
      this.modal.close(result);
      this.busy = false;
    },err=>{
      this.messageService.add({ life: 4000, detail: 'There was a problem adding this bundle.'});
      this.busy = false;
    });
  }

  updateFields(event){
    var country = this.countries.filter(x=>{return x.value === event.value})[0];
    console.log(country);
    this.BundleForm.controls['locale'].setValue(country.locale);
    this.BundleForm.controls['currency'].setValue(country.currency);
    this.BundleForm.controls['currencySymbol'].setValue(country.currencySymbol);
  }

}